enum CardHolderType {
  AUTHORIZED_USER = "AUTHORIZED_USER",
  BUSINESS = "BUSINESS",
}

export default CardHolderType;
